import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import Close from "../../Static assets/Crosses/Cross-01.png";

function CloseButton(props) {
  const { setShowComment, setSelected } = props;

  return (
    <img
      onClick={(event) => {
        setSelected(null);
      }}
      className={styles.close}
      src={Close}
    />
  );
}

export default CloseButton;
